// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 500px) {

    .scl--wpchs-cont-stl-bo {
        padding-left: var(--global-mobile-padding-left);
        padding-right: var(--global-mobile-padding-right);
    }

    .scl--web-component-talent-list-container .scl--web-component-talent-step-item .scl--web-component-talent-content{
        gap: 27px;
    }

    .scl--web-page-career-join-us-section .scl--web-page-career-join-us-title-side .scl--web-page-career-view-all-button{
        width: 100%;
        height: 49px;
        margin-top: 40px;
    }

    .scl--web-page-career-join-us-section .scl--web-page-career-join-us-title-side .scl--web-component-round-button-text{
        font-size: 24px;
    }

    .scl--web-page-career-join-us-section .scl--web-page-career-join-us-title-side .scl--web-component-round-button-text .scl--web-component-round-button-icon svg{
        width: 23px;
        height: 23px;
    }

    .scl--wpchs-cont-stl-bo .scl--web-component-hero-title span{
        font-size: 50px;
        line-height: 60px;
    }

    .scl--wpchs-cont-stl-bo .scl--web-component-round-button{
        width: 305px;
        height: 49px;
    }

    .scl--wpchs-cont-stl-bo .scl--web-component-round-button .scl--web-component-round-button-text{
        font-size: 24px;
    }

    .scl--web-page-career-join-us-section-title .scl--web-component-section-title-text{
        font-size: 60px;
    }

    .scl--wpcjus-section-job-seek{
        padding-left: var(--global-mobile-padding-left);
        padding-right: var(--global-mobile-padding-right);
    }

    .scl--web-page-career-join-us-job-list-side .scl--web-component-job-role-title{
        font-size: 24px;
    }

    .scl--web-page-career-our-talent-content{
        padding-left: var(--global-mobile-padding-left);
        padding-right: var(--global-mobile-padding-right);
    }

    .scl--web-page-career-our-talent-content .sfcl--web-component-section-title-text-container h2{
        text-align: start;
        font-size: 60px;
    }

    .scl--web-page-career-our-talent-content .scl--web-component-section-description-text{
        margin-top: 20px;
        line-height: 40px;
        font-size: 24px;
    }

    .scl--web-page-career-our-talent-content .scl--web-component-talent-step-item{
        gap: 16px;
    }

    .scl--web-page-career-our-talent-content .scl--web-component-talent-step-item .scl--web-component-talent-description{
        font-size: 24px;
        width: 100%;
    }

    .scl--web-page-career-our-talent-content .scl--web-component-talent-list-container .scl--web-component-talent-step-number{
        font-size: 18px;
    }

    .scl--web-page-career-our-talent-content .scl--web-component-talent-list-container .scl--web-component-talent-title{
        font-size: 34px;
    }

    .scl--web-page-career-our-talent-content .scl--web-component-talent-step-item .scl--web-component-talent-content button{
        height: 55px;
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/career/css/careerSm.css"],"names":[],"mappings":"AAAA;;IAEI;QACI,+CAA+C;QAC/C,iDAAiD;IACrD;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,+CAA+C;QAC/C,iDAAiD;IACrD;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,+CAA+C;QAC/C,iDAAiD;IACrD;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;AACJ","sourcesContent":["@media (max-width: 500px) {\n\n    .scl--wpchs-cont-stl-bo {\n        padding-left: var(--global-mobile-padding-left);\n        padding-right: var(--global-mobile-padding-right);\n    }\n\n    .scl--web-component-talent-list-container .scl--web-component-talent-step-item .scl--web-component-talent-content{\n        gap: 27px;\n    }\n\n    .scl--web-page-career-join-us-section .scl--web-page-career-join-us-title-side .scl--web-page-career-view-all-button{\n        width: 100%;\n        height: 49px;\n        margin-top: 40px;\n    }\n\n    .scl--web-page-career-join-us-section .scl--web-page-career-join-us-title-side .scl--web-component-round-button-text{\n        font-size: 24px;\n    }\n\n    .scl--web-page-career-join-us-section .scl--web-page-career-join-us-title-side .scl--web-component-round-button-text .scl--web-component-round-button-icon svg{\n        width: 23px;\n        height: 23px;\n    }\n\n    .scl--wpchs-cont-stl-bo .scl--web-component-hero-title span{\n        font-size: 50px;\n        line-height: 60px;\n    }\n\n    .scl--wpchs-cont-stl-bo .scl--web-component-round-button{\n        width: 305px;\n        height: 49px;\n    }\n\n    .scl--wpchs-cont-stl-bo .scl--web-component-round-button .scl--web-component-round-button-text{\n        font-size: 24px;\n    }\n\n    .scl--web-page-career-join-us-section-title .scl--web-component-section-title-text{\n        font-size: 60px;\n    }\n\n    .scl--wpcjus-section-job-seek{\n        padding-left: var(--global-mobile-padding-left);\n        padding-right: var(--global-mobile-padding-right);\n    }\n\n    .scl--web-page-career-join-us-job-list-side .scl--web-component-job-role-title{\n        font-size: 24px;\n    }\n\n    .scl--web-page-career-our-talent-content{\n        padding-left: var(--global-mobile-padding-left);\n        padding-right: var(--global-mobile-padding-right);\n    }\n\n    .scl--web-page-career-our-talent-content .sfcl--web-component-section-title-text-container h2{\n        text-align: start;\n        font-size: 60px;\n    }\n\n    .scl--web-page-career-our-talent-content .scl--web-component-section-description-text{\n        margin-top: 20px;\n        line-height: 40px;\n        font-size: 24px;\n    }\n\n    .scl--web-page-career-our-talent-content .scl--web-component-talent-step-item{\n        gap: 16px;\n    }\n\n    .scl--web-page-career-our-talent-content .scl--web-component-talent-step-item .scl--web-component-talent-description{\n        font-size: 24px;\n        width: 100%;\n    }\n\n    .scl--web-page-career-our-talent-content .scl--web-component-talent-list-container .scl--web-component-talent-step-number{\n        font-size: 18px;\n    }\n\n    .scl--web-page-career-our-talent-content .scl--web-component-talent-list-container .scl--web-component-talent-title{\n        font-size: 34px;\n    }\n\n    .scl--web-page-career-our-talent-content .scl--web-component-talent-step-item .scl--web-component-talent-content button{\n        height: 55px;\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
